<template>
  <div class="login-page">
    <!-- 顶部栏 -->
    <div class="login-header">
      <div class="header-title">帐号登录</div>
      <div class="header-back" @click="goBack">
        <img class="back-icon" src="@/assets/image/frame.png" />
        <span class="back-text">返回</span>
      </div>
    </div>

    <!-- LOGO -->
    <div class="login-logo">
      <!-- <img src="@/assets/image/logo.jpg" style="width: 120px; height: 120px" /> -->
      <img src="@/assets/image/logo2.png" style="width: 90px" />
    </div>

    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- 登录方式切换 -->
      <div class="login-tabs">
        <div class="login-tab" :class="{ active: loginType === 'account' }" @click="loginType = 'account'">账号登录</div>
        <div class="login-tab" :class="{ active: loginType === 'sms' }" @click="loginType = 'sms'">验证码登录</div>
      </div>

      <div style="padding: 0 50px 31px 50px">
        <!-- 账号登录表单 -->
        <div v-if="loginType === 'account'" class="login-form">
          <div class="form-item">
            <div class="form-label">手机号</div>
            <input v-model="form.phone" type="text" placeholder="请输入手机号" maxlength="11" class="form-input" @input="form.phone = form.phone.replace(/[^\d]/g, '')" />
          </div>
          <div class="form-item" style="margin-top: 20px">
            <div class="form-label">密码</div>
            <div class="password-input-wrapper">
              <input v-model="form.password" :type="showPassword ? 'text' : 'password'" placeholder="请输入密码" class="form-input" />
              <img class="password-toggle" :src="showPassword ? showImg : showNoImg" @click="showPassword = !showPassword" />
            </div>
          </div>
          <div class="form-extra">
            <span class="forgot-link" @click="goForgot">忘记密码？</span>
          </div>
        </div>

        <!-- 验证码登录表单 -->
        <div v-else class="login-form">
          <div class="form-item">
            <div class="form-label">手机号</div>
            <input v-model="form.phone" type="text" placeholder="请输入手机号" maxlength="11" class="form-input" @input="form.phone = form.phone.replace(/[^\d]/g, '')" />
          </div>
          <div class="form-item" style="margin-top: 20px">
            <div class="form-label">验证码</div>
            <div class="sms-row">
              <input v-model="form.smsCode" type="text" placeholder="请输入验证码" class="form-input" />
              <button class="sms-btn" :disabled="smsCountdown > 0" @click="sendSmsCode">
                {{ smsCountdown > 0 ? `${smsCountdown}s` : "获取验证码" }}
              </button>
            </div>
          </div>
        </div>

        <!-- 登录按钮 -->
        <button class="login-submit" :disabled="loading || fetchingRole" @click="handleLogin">
          {{ loading ? "登录中..." : fetchingRole ? "获取角色中..." : "立即登录" }}
        </button>

        <!-- 协议勾选 -->
        <div class="agreement-row">
          <img class="agree-icon" :src="agreed ? require('@/assets/image/selected.png') : require('@/assets/image/no-selected.png')" @click="agreed = !agreed" />
          <div style="font-size: 20px; margin-left: 9px; color: #999999">
            <span>登录即代表同意<span class="agreement-link" @click="goAgreement">《用户协议》</span> 和 <span class="agreement-link" @click="goPrivacy">《隐私协议》</span> </span>
          </div>
        </div>

        <!-- 去注册 -->
        <div @click="goRegister" class="register-row">
          <span class="register-link">还没有帐号？去注册</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginByPass, loginByVerCode, getVerCode } from "@/api";
import { getMyUserInfo } from "@/api/user";

export default {
  name: "Login",
  data() {
    return {
      loginType: "account",
      loading: false,
      fetchingRole: false,
      form: {
        phone: "",
        password: "",
        smsCode: "",
      },
      agreed: true,
      showPassword: false,
      showImg: require("@/assets/image/show.png"),
      showNoImg: require("@/assets/image/show-no.png"),
      smsCountdown: 0,
      smsTimer: null,
    };
  },
  beforeDestroy() {
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    sendSmsCode() {
      if (!this.form.phone) {
        this.$message && this.$message.warning("请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message && this.$message.warning("请输入正确的手机号");
        return;
      }

      getVerCode({ phoneNumber: this.form.phone })
        .then(() => {
          this.$message && this.$message.success("验证码已发送");
          this.smsCountdown = 60;
          this.smsTimer = setInterval(() => {
            this.smsCountdown--;
            if (this.smsCountdown <= 0) {
              clearInterval(this.smsTimer);
            }
          }, 1000);
        })
        .catch((err) => {
          this.$message && this.$message.error(err.message || "验证码发送失败");
        });
    },
    async handleLogin() {
      if (!this.agreed) {
        this.$message.warning("请先同意用户协议和隐私协议");
        return;
      }

      // 手机号校验
      if (!this.form.phone || !/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }

      this.loading = true;

      try {
        let res;
        if (this.loginType === "account") {
          if (!this.form.password) {
            this.$message.warning("请输入密码");
            this.loading = false;
            return;
          }
          res = await loginByPass({
            phoneNumber: this.form.phone,
            password: this.form.password,
          });
        } else {
          if (!this.form.smsCode) {
            this.$message.warning("请输入验证码");
            this.loading = false;
            return;
          }
          res = await loginByVerCode({
            phoneNumber: this.form.phone,
            verCode: this.form.smsCode,
          });
        }

        this.loading = false;

        if (res.code === 200) {
          localStorage.setItem("token", res.data.token);
          this.fetchingRole = true;
          try {
            const userRes = await getMyUserInfo();
            this.fetchingRole = false;
            const role = userRes.code === 200 && userRes.data && userRes.data.role ? userRes.data.role : "";
            localStorage.setItem("role", role);
            localStorage.setItem("userRes", JSON.stringify(userRes.data));
            this.$router.push("/home");
            this.$message.success("登录成功");
          } catch {
            this.fetchingRole = false;
            this.$router.push("/home");
            this.$message.success("登录成功");
          }
        } else {
          this.$message.error(res.msg || res.message || "登录失败");
        }
      } catch (error) {
        this.loading = false;
        this.$message.error(error.message || "登录失败");
      }
    },
    goForgot() {
      this.$router.push("/forgot-password");
    },
    goRegister() {
      this.$router.push("/register");
    },
    goAgreement() {
      this.$router.push("/agreement");
    },
    goPrivacy() {
      this.$router.push("/privacy");
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #e8f0fe;
}

.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 360px 0 360px;
}

.header-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.header-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.back-icon {
  width: 24px;
  height: 24px;
}

.back-text {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  margin-left: 6px;
}

.login-logo {
  text-align: center;
  margin-top: 39px;
  margin-bottom: 30px;
}

.login-card {
  width: 690px;
  margin: 0 auto;
  background: #fff;
  border-radius: 30px;
}

.login-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  border-bottom: 1px solid #e8e8e8;
  padding: 36px 0 19px 0;
}

.login-tab {
  padding: 0 16px;
  cursor: pointer;
  color: #999;
  font-size: 26px;
  position: relative;
}

.login-tab.active {
  color: #333;
  font-weight: bold;
}

.login-tab.active::after {
  content: "";
  position: absolute;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
  width: 42px;
  height: 2px;
  background: #1869ff;
}

.form-item {
  /* margin-bottom: 16px; */
}

.form-label {
  font-size: 20px;
  color: #333;
  margin-bottom: 9px;
}

.form-input {
  width: 100%;
  height: 60px;
  padding: 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  font-size: 20px;
  box-sizing: border-box;
  outline: none;
}

.form-input:focus {
  border-color: #1869ff;
}

.password-input-wrapper {
  position: relative;
}

.password-input-wrapper .form-input {
  padding-right: 48px;
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  cursor: pointer;
  user-select: none;
}

.password-toggle:hover {
  opacity: 0.7;
}

.sms-row {
  display: flex;
  gap: 8px;
  position: relative;
}

.sms-row .form-input {
  flex: 1;
}

.sms-btn {
  border: unset;
  background: rgba(0, 0, 0, 0);
  color: #1869ff;
  cursor: pointer;
  font-size: 20px;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}

.sms-btn:disabled {
  border-color: unset;
  color: #1869ff;
  cursor: not-allowed;
}

.form-extra {
  text-align: right;
  margin-top: 15px;
}

.forgot-link {
  font-size: 20px;
  color: #1869ff;
  cursor: pointer;
}

.login-submit {
  width: 100%;
  height: 60px;
  background: #1869ff;
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 20px;
  cursor: pointer;
  margin-top: 64px;
}

.agreement-row {
  margin-top: 30px;
  line-height: normal;
  display: flex;
  align-items: center;
}

.agree-icon {
  width: 22px;
  height: 22px;
  cursor: pointer;
  flex-shrink: 0;
}

.agreement-link {
  color: #333333;
  cursor: pointer;
}

.agreement-link:hover {
  text-decoration: underline;
}

.register-row {
  color: #1869ff;
  cursor: pointer;
  text-align: center;
  margin-top: 43px;
  font-size: 20px;
}
.register-link:hover {
  border-bottom: 1px solid #bcbcbc;
}
</style>
